import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Users, CheckCircle, XCircle, MessageSquare } from 'lucide-react';

export default function AlumniRequestsTab({ myRequests, user, respondToRequest }) {
  if (myRequests.as_mentee.length === 0 && myRequests.as_mentor.length === 0) {
    return (
      <Card className="border-0 shadow-sm rounded-2xl">
        <CardContent className="p-8 text-center">
          <MessageSquare className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
          <p className="text-muted-foreground">No mentorship requests.</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      {myRequests.as_mentee.length > 0 && (
        <Card className="border-0 shadow-sm rounded-2xl">
          <CardHeader className="pb-3">
            <CardTitle className="text-base font-semibold" style={{ fontFamily: 'Manrope' }}>My Requests (Seeking Mentor)</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            {myRequests.as_mentee.map(req => (
              <div key={req.id} className="flex items-center justify-between p-3 bg-muted/30 rounded-xl">
                <div>
                  <p className="font-medium">To: {req.mentor_name}</p>
                  <p className="text-sm text-muted-foreground">{req.message || 'No message'}</p>
                </div>
                <Badge className={
                  req.status === 'accepted' ? 'bg-emerald-100 text-emerald-700' :
                  req.status === 'declined' ? 'bg-red-100 text-red-700' :
                  'bg-amber-100 text-amber-700'
                }>{req.status}</Badge>
              </div>
            ))}
          </CardContent>
        </Card>
      )}
      
      {myRequests.as_mentor.length > 0 && (
        <Card className="border-0 shadow-sm rounded-2xl">
          <CardHeader className="pb-3">
            <CardTitle className="text-base font-semibold" style={{ fontFamily: 'Manrope' }}>Incoming Requests (As Mentor)</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            {myRequests.as_mentor.map(req => (
              <div key={req.id} className="p-3 bg-muted/30 rounded-xl">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="font-medium">From: {req.mentee_name}</p>
                    <p className="text-sm text-muted-foreground mt-1">{req.message || 'No message'}</p>
                    {req.areas_of_interest?.length > 0 && (
                      <div className="flex flex-wrap gap-1 mt-2">
                        {req.areas_of_interest.map((area, idx) => (
                          <Badge key={`item-${idx}`} variant="outline" className="text-xs">{area}</Badge>
                        ))}
                      </div>
                    )}
                  </div>
                  {req.status === 'pending' ? (
                    <div className="flex gap-2 shrink-0">
                      <Button size="sm" onClick={() => respondToRequest(req.id, 'accepted')} className="bg-emerald-600 hover:bg-emerald-700 text-white rounded-full gap-1">
                        <CheckCircle size={14} /> Accept
                      </Button>
                      <Button size="sm" variant="outline" onClick={() => respondToRequest(req.id, 'declined')} className="rounded-full gap-1">
                        <XCircle size={14} /> Decline
                      </Button>
                    </div>
                  ) : (
                    <Badge className={req.status === 'accepted' ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'}>{req.status}</Badge>
                  )}
                </div>
              </div>
            ))}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
